module.exports = __webpack_public_path__ + "img/walkthrough_illust22@2x.20ed264c.png";